var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoad = function SvgRoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.677 7.131a1.25 1.25 0 0 1 .858 1.546L7.87 32.01a1.25 1.25 0 0 1-2.404-.687L12.13 7.99a1.25 1.25 0 0 1 1.546-.859M26.323 7.131a1.25 1.25 0 0 1 1.546.859l6.666 23.333a1.25 1.25 0 1 1-2.404.687L25.465 8.677a1.25 1.25 0 0 1 .858-1.546M21.25 10a1.25 1.25 0 1 0-2.5 0v3.333a1.25 1.25 0 1 0 2.5 0zM20 17.084c.69 0 1.25.56 1.25 1.25v3.333a1.25 1.25 0 1 1-2.5 0v-3.334c0-.69.56-1.25 1.25-1.25M21.25 26.667a1.25 1.25 0 1 0-2.5 0V30a1.25 1.25 0 1 0 2.5 0z"
  })));
};
export default SvgRoad;